import React from 'react'
import { Redirect } from 'react-router-dom'
import { Router, Route, Switch } from 'react-router-dom'
import SignIn from '../layouts/SignIn/SignIn.jsx'
import DashboardAdmin from '../layouts/DashboardAdmin/DashboardAdmin.jsx'
import ResetPassword from '../layouts/ResetPassword/ResetPassword.jsx'


const PublicRouters = (props) => {
  return(
    <Router history={props.history}>
        <Switch>
          <Route
            path={'/signin'}
            component={SignIn}
          />
          <Route
            path={'/user-passwordreset'}
            component={ResetPassword}
          />
          <Route
            path={'/'}
            component={DashboardAdmin}
          />
          <Redirect to={'/signin'}/>
        </Switch>
    </Router>
  );
}

export default PublicRouters
